angular
	.module 'App.Repository'
	.factory 'UserShopRepository', ['BaseRepository', 'UserInformation', (BaseRepository, UserInformation) ->
		class UserShopRepository extends BaseRepository
			@resource = '/shops'
			@isRestricted = true

			getEntities: (query = null) ->
				user = UserInformation.getSubUser()

				if !user?
					return super(query)

				query ?= @getQuery()
				query.criteria 'id', 'IN', user.shops.join()

				return super(query)

		return new UserShopRepository
	]
